<template>
  <div class="catalog__category-sorter">
    <span class="show-for-between-medium-small">{{ $t('Sort by') }}:</span>
    <select @change="updatePage($event)">
      <option :value="JSON.stringify(option.sorting)" v-for="option in sortOptions" :selected="checkSelected(option.sorting)">{{ $t(option.name) }}</option>
    </select>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';

  @Component({
    name: 'product-list-toolbar-sort-select'
  })

  export default class extends Vue {
    @Prop({required: true}) readonly dataSource: string;

    readonly sortOptions: object = [{
      name: 'Name (A-Z)',
      sorting: {name_s: 'asc'},
    }, {
      name: 'Name (Z-A)',
      sorting: {name_s: 'desc'},
    }, {
      name: 'Price (Ascending)',
      sorting: {price: 'asc'},
    }, {
      name: 'Price (Descending)',
      sorting: {price: 'desc'},
    }];

    private get currentSorting(): object {
      return typeof this.$store.getters[`${this.dataSource}/currentSort`] !== 'undefined' ? this.$store.getters[`${this.dataSource}/currentSort`] : {};
    }

    private updatePage(sorting): void {
      this.$store.dispatch(`${this.dataSource}/updatePageSort`, JSON.parse(sorting.target.value));
    }

    private checkSelected(selection): boolean {
      return JSON.stringify(this.currentSorting) === JSON.stringify(selection);
    }
  }
</script>
